import { render, staticRenderFns } from "./JobPageBaseInfo.vue?vue&type=template&id=52f9afe8&scoped=true&"
import script from "./JobPageBaseInfo.vue?vue&type=script&lang=js&"
export * from "./JobPageBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./JobPageBaseInfo.vue?vue&type=style&index=0&id=52f9afe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9afe8",
  null
  
)

export default component.exports